import React from "react";
import { Box, Typography } from "@mui/material";

type RouteMapErrorBoundaryProps = {
  children: React.ReactNode;
};

type RouteMapErrorBoundaryState = {
  error: Error | null;
};

export class RouteMapErrorBoundary extends React.Component<
  RouteMapErrorBoundaryProps,
  RouteMapErrorBoundaryState
> {
  state: RouteMapErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): RouteMapErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error("Route map render failed:", error, info.componentStack);
  }

  componentDidUpdate(prevProps: RouteMapErrorBoundaryProps): void {
    if (prevProps.children !== this.props.children && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <Box
          sx={{
            flex: 1,
            minHeight: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 2,
            textAlign: "center",
            bgcolor: "#fff",
            borderRadius: "12px",
            border: "1px solid #e5e9ef",
          }}
        >
          <Typography variant="body2" sx={{ color: "#64748b" }}>
            {this.state.error.message || "Map unavailable. Please try again."}
          </Typography>
        </Box>
      );
    }

    return this.props.children;
  }
}
